// ** Component Imports
import { Typography } from '../../index'

// ** Styled Components & Types
import { type ColorVariant, StyledChip } from './styles'

interface IProps {
	color: ColorVariant
	label: string
	startIcon?: JSX.Element
}

export const Chip = ({ color, label, startIcon }: IProps) => {
	return (
		<StyledChip color={color}>
			{startIcon !== undefined && startIcon}
			<Typography variant='body2' weight='semi-bold'>
				{label}
			</Typography>
		</StyledChip>
	)
}
